import { useState, useEffect, useCallback } from 'react';
import { fetchGet } from '../../Util/fetchAPI';
import useInterval from '../../Util/useInterval';
import { Flag } from './useValidationFlags';

export type TaskFlags = {
  task_id: string;
  flags: Flag[];
};
const fetchTimeMs: number = 10000;

export default function useValidationFlagsPerTask(
  runId?: string,
  baseLabelUrl: string = '/gateway/label-assistant-v2/api/v1/label'
) {
  const [flags, setFlags] = useState<TaskFlags[]>([]);

  const fetch = useCallback(() => {
    if(!runId) {
      return;
    }
    fetchGet(
      baseLabelUrl+'/run/'+runId+'/flags'
    ).then((taskFlags: TaskFlags[] | undefined) => {
      if(taskFlags) {
        setFlags(taskFlags);
      }
    });
  }, [baseLabelUrl, runId]);

  useEffect(() => {
    // Initially poll all flags
    fetch();
  }, [fetch]);

  // Fetch flags every x seconds
  useInterval(() => {
    fetch();
  }, fetchTimeMs);

  return { flags };
};
